const RootErrorFallback = () => {
  return (
    <div>
      <h1>Oops! Something went wrong.</h1>
      <p>
        An unexpected error occured. If this continues please contact
        support@optionsai.com
      </p>
      <button
        onClick={() => {
          setTimeout(() => {
            window.location.reload();
            window.location.href = '/dashboard';
          }, 300);
        }}
      >
        Reload Page
      </button>
    </div>
  );
};

export default RootErrorFallback;
